import { automatedEmailsSaga } from '@store/features/automatedEmails/sagas';
import { dashboardSaga } from '@store/features/dashboard/sagas';
import emailAnalyticsSaga from '@store/features/emailAnalytics/sagas';
import { emailAuditSaga } from '@store/features/emailAudit/sagas';
import { jobApplicantsSaga } from '@store/features/jobApplicants/sagas';
import {
    loginUserFromSessionSaga,
    loginUserProfileSaga,
    watchLogoutUserProfileSaga,
    watchUpdateUserProfileSaga
} from '@store/features/loginUserProfile/sagas';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    loginUserProfileSaga(),
    loginUserFromSessionSaga(),
    jobApplicantsSaga(),
    watchLogoutUserProfileSaga(),
    watchUpdateUserProfileSaga(),
    automatedEmailsSaga(),
    emailAnalyticsSaga(),
    emailAuditSaga(),
    dashboardSaga(),
  ]);
}
